import { Dealer } from './Dealer';
import { DspEntity, OemProgram } from './DspEntity';
import { SasAccount } from './SasAccount';
import { CampaignFee } from './Campaign';
import { AgencyOem } from './Oem';
import { AgencyBrand } from './Brand';

export class Agency {
    id?: number;
    name: string = '';
    hostname?: string = '';
    logoUrl: string = '';
    iconUrl?: string = '';
    dealers: Dealer[] = [];
    dashboardId: string | null = null;
    apiKey?: string | null;
    apiIncludeCostMetrics?: boolean = false;
    cpTemplate?: string = '';
    cpSource?: string = '';
    cpMedium?: string = '';
    cpCampaign?: string = '';
    cpTerm?: string = '';
    cpContent?: string = '';
    dspEntities: DspEntity[] = [];
    sasAccounts: SasAccount[] = [];
    crmDataNotifications?: string | null = null;
    activeStatus: boolean = true;
    activeCampaigns: boolean = true;
    activeReporting: boolean = true;
    activeQuickSightReporting: boolean = true;
    activeAttribution: boolean = true;
    activeData: boolean = false;
    activeApiDocs: boolean = true;
    activeAdvertisers: boolean = true;
    activeCrmUpload: boolean = true;
    activeInsights: boolean = true;
    activeAdServing: boolean = false;
    creativeStudioIsActive: boolean = true;
    accessCreativeStudio: boolean = false;
    activeOem: boolean = false;
    creativeStudioUserId: string | null = null;
    polkSalesIsActive: boolean = false;
    campaignFee?: CampaignFee = new CampaignFee();
    needsPolkAudiences: boolean = true;
    firstPartyDataFtpUser: string | null = null;
    firstPartyDataFailureEmail: string | null = null;
    firstPartyDataResultsEmail: string | null = null;
    timezone?: string = '';
    agencyFirstPartyDealers: AgencyFirstPartyDealer[] = [];
    tfUserIsActive: boolean = false;
    prioritizeReporting: boolean = false;
    tfUserEmail?: string = '';
    tfCustomerId?: string = '';
    tfPassword?: string = '';
    gatewayAmazonDSPIsActive: number = 3;
    exportSetting?: string[];

    brands?: Partial<AgencyBrand>[] = [];
    oems?: Partial<AgencyOem>[] = [];
    oemPrograms?: Partial<OemProgram>[] = [];

    whiteLabelPortalEnabled: boolean = false;
    supportEmail?: string = '';
    adServingEnabled: boolean = false;
    sourceFolderPath?: string | null = null;
    imageSourceFolderPath?: string | null = null;
    termsOfService?: string = '';
    senderEmail?: string = '';
    senderEmailDomainVerified?: boolean = false;
}

export interface AgencyFirstPartyDealer {
    id?: number;
    agencyId?: number;
    dealerId?: number | null;
    dealer?: Dealer | null;
    dealerCode?: string;
    fileName?: string;
    dataSetName?: string;
}

export interface AgencyFirstPartyUpload {
    id?: number;
    amcUploadId?: number;
    agencyFirstPartyDealerId?: number;
    status?: string;
    s3key?: string;
    updateDate?: Date | null;
}

export interface ExportSetting {
    id: number;
    sources: string;
    sourcesOndemand?: string;
    platforms?: string;
    platformsOndemand?: string;
    agencyId: number;
    fromDate?: string;
    toDate?: string;
    range?: string;
}
